export const clients = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'surface',

  Sidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    padding: 'B C',
    gap: 'B',
    overflow: 'auto',
    '@tabletS': { padding: 'A B' },
    '@mobileL': { padding: 'A' },

    PageHeader: {
      flow: 'x',
      align: 'center space-between',
      '@mobileL': { flow: 'y', gap: 'A' },
      HeaderTitle: { tag: 'h1', text: '{{ clientsTitle | polyglot }}', fontSize: 'C', fontWeight: '800', color: 'text', '@mobileL': { fontSize: 'B' } },
      HeaderRight: {
        flow: 'x', gap: 'A', align: 'center',
        '@mobileL': { flexWrap: 'wrap' },
        SearchInput: { tag: 'input', type: 'text', name: 'search', placeholder: '{{ clientsSearchPlaceholder | polyglot }}', padding: 'Z A', fontSize: 'A', background: 'surfaceCard', border: '1px solid surfaceBorderStrong', borderRadius: 'Z', color: 'text', width: 'F' },
        ThemeToggle: {},
      },
    },

    ClientsList: {
      flow: 'x',
      gap: 'B',
      '@tabletS': { flow: 'y' },

      ClientCards: {
        flow: 'y',
        gap: 'Z',
        flex: '1',

        Client1: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: (el, s) => s.root.activeClientId === 1 ? 'greenBg' : 'surfaceCard',
          border: (el, s) => s.root.activeClientId === 1 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          cursor: 'pointer',
          transition: 'background 150ms',
          onClick: (e, el, s) => s.root.update({ activeClientId: 1 }),
          ClientLeft: {
            flow: 'x', gap: 'Z', align: 'center',
            ClientAvatar: { width: 'B', height: 'B', borderRadius: '100%', background: 'greenBg', color: 'green', flow: 'x', align: 'center center', fontSize: 'Z', fontWeight: '700', text: '{{ clientsAvatar1 | polyglot }}', flexShrink: '0' },
            ClientInfo: {
              flow: 'y', gap: 'Y',
              ClientName: { text: '{{ clientName1 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
              ClientContact: { text: '{{ clientsContact1 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
            },
          },
          ClientRight: {
            flow: 'y', gap: 'Y', align: 'flex-end',
            CasesCount: { text: '{{ clientsActiveCases1 | polyglot }}', fontSize: 'Z', color: 'green' },
            TotalBilled: { text: '{{ clientsPaid1 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          },
        },
        Client2: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: (el, s) => s.root.activeClientId === 2 ? 'greenBg' : 'surfaceCard',
          border: (el, s) => s.root.activeClientId === 2 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          cursor: 'pointer',
          transition: 'background 150ms',
          onClick: (e, el, s) => s.root.update({ activeClientId: 2 }),
          ClientLeft: {
            flow: 'x', gap: 'Z', align: 'center',
            ClientAvatar: { width: 'B', height: 'B', borderRadius: '100%', background: 'purpleBg', color: 'purple', flow: 'x', align: 'center center', fontSize: 'Z', fontWeight: '700', text: '{{ clientsAvatar2 | polyglot }}', flexShrink: '0' },
            ClientInfo: {
              flow: 'y', gap: 'Y',
              ClientName: { text: '{{ clientName2 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
              ClientContact: { text: '{{ clientsContact2 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
            },
          },
          ClientRight: {
            flow: 'y', gap: 'Y', align: 'flex-end',
            CasesCount: { text: '{{ clientsActiveCases2 | polyglot }}', fontSize: 'Z', color: 'green' },
            TotalBilled: { text: '{{ clientsPaid2 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          },
        },
        Client3: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: (el, s) => s.root.activeClientId === 3 ? 'greenBg' : 'surfaceCard',
          border: (el, s) => s.root.activeClientId === 3 ? '1px solid greenBorder' : '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          cursor: 'pointer',
          transition: 'background 150ms',
          onClick: (e, el, s) => s.root.update({ activeClientId: 3 }),
          ClientLeft: {
            flow: 'x', gap: 'Z', align: 'center',
            ClientAvatar: { width: 'B', height: 'B', borderRadius: '100%', background: 'blueBg', color: 'blue', flow: 'x', align: 'center center', fontSize: 'Z', fontWeight: '700', text: '{{ clientsAvatar3 | polyglot }}', flexShrink: '0' },
            ClientInfo: {
              flow: 'y', gap: 'Y',
              ClientName: { text: '{{ clientName3 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
              ClientContact: { text: '{{ clientsContact3 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
            },
          },
          ClientRight: {
            flow: 'y', gap: 'Y', align: 'flex-end',
            CasesCount: { text: '{{ clientsActiveCases3 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
            TotalBilled: { text: '{{ clientsPaid3 | polyglot }}', fontSize: 'Z', color: 'textMuted' },
          },
        },
      },

      // Client detail
      ClientDetail: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        maxWidth: 'H',
        '@tabletS': { maxWidth: '100%', width: '100%' },
        padding: 'B',
        background: 'surfaceMid',
        border: '1px solid surfaceBorderStrong',
        borderRadius: 'Z',
        show: (el, s) => s.root.activeClientId !== null,

        DetailHeader: {
          flow: 'x', align: 'center space-between',
          padding: '0 0 A 0', borderBottom: '1px solid surfaceBorderStrong',
          DetailTitle: { tag: 'h3', text: '{{ clientsProfile | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },
          CloseBtn: { extends: 'Button', text: '✕', theme: 'transparent', color: 'textSoft', fontSize: 'A', padding: 'Z', cursor: 'pointer', borderRadius: 'Z', onClick: (e, el, s) => s.root.update({ activeClientId: null }) },
        },

        ContactSection: {
          flow: 'y', gap: 'Z', padding: 'A', background: 'surfaceCard', border: '1px solid surfaceBorder', borderRadius: 'Z',
          SectionLabel: { text: '{{ clientsContactLabel | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'textMuted' },
          ContactName: {
            text: (el, s) => {
              if (s.root.activeClientId === 1) return '{{ clientName1 | polyglot }}'
              if (s.root.activeClientId === 2) return '{{ clientName2 | polyglot }}'
              return '{{ clientName3 | polyglot }}'
            },
            fontSize: 'A', fontWeight: '600', color: 'text',
          },
          ContactDetails: {
            flow: 'x', gap: 'B', flexWrap: 'wrap',
            PhoneRow: { flow: 'x', gap: 'Y', align: 'center', PhoneIcon: { extends: 'Icon', icon: 'phone', width: 'Z', height: 'Z', color: 'textMuted' }, PhoneVal: { text: (el, s) => { if (s.root.activeClientId === 1) return '599123456'; if (s.root.activeClientId === 2) return '577234567'; return '571456789' }, fontSize: 'Z', color: 'textSoft' } },
            EmailRow: { flow: 'x', gap: 'Y', align: 'center', MailIcon: { extends: 'Icon', icon: 'mail', width: 'Z', height: 'Z', color: 'textMuted' }, EmailVal: { text: (el, s) => { if (s.root.activeClientId === 1) return 'g.mamulasvili@gmail.com'; if (s.root.activeClientId === 2) return 'mari.k@mail.ru'; return 'lela.g@inbox.ge' }, fontSize: 'Z', color: 'textSoft' } },
          },
        },

        CasesSection: {
          flow: 'y', gap: 'Z',
          SectionLabel: { text: '{{ casesTitle | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
          CaseLink1: { extends: 'Link', href: '/cases', text: '{{ clientsCaseLink1 | polyglot }}', fontSize: 'Z', color: 'green', textDecoration: 'none', show: (el, s) => s.root.activeClientId === 1, onClick: (e, el, s) => s.root.update({ activeCaseId: 1 }) },
          CaseLink2: { extends: 'Link', href: '/cases', text: '{{ clientsCaseLink2 | polyglot }}', fontSize: 'Z', color: 'green', textDecoration: 'none', show: (el, s) => s.root.activeClientId === 2, onClick: (e, el, s) => s.root.update({ activeCaseId: 2 }) },
          CaseLink3: { text: '{{ clientsNoCases | polyglot }}', fontSize: 'Z', color: 'textMuted', fontStyle: 'italic', show: (el, s) => s.root.activeClientId === 3 },
        },

        InvoicesSection: {
          flow: 'y', gap: 'Z',
          SectionLabel: { text: '{{ clientsInvoiceHistory | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
          InvRow1: { flow: 'x', align: 'center space-between', padding: 'Z', background: 'surfaceCard', borderRadius: 'Z', show: (el, s) => s.root.activeClientId === 1, InvNum: { text: 'INV-2024-031', fontSize: 'Z', color: 'textSoft' }, InvAmount: { text: '₾1,200', fontSize: 'Z', fontWeight: '600', color: 'text' }, InvStatus: { extends: 'StatusPending', text: '{{ clientsUnpaid | polyglot }}' } },
          InvRow2: { flow: 'x', align: 'center space-between', padding: 'Z', background: 'surfaceCard', borderRadius: 'Z', show: (el, s) => s.root.activeClientId === 2, InvNum: { text: 'INV-2024-030', fontSize: 'Z', color: 'textSoft' }, InvAmount: { text: '₾640', fontSize: 'Z', fontWeight: '600', color: 'text' }, InvStatus: { extends: 'StatusConfirmed', text: '{{ clientsPaid | polyglot }}' } },
        },

        PortalInviteBtn: {
          extends: 'Button',
          text: '{{ clientsPortalInvite | polyglot }}',
          theme: 'ghost',
          padding: 'Z A',
          fontSize: 'Z',
          borderRadius: 'Z',
          cursor: 'pointer',
          width: '100%',
          textAlign: 'center',
        },
      },
    },
  },
}
